import { motion } from "framer-motion";
import { DownloadCloud, Cpu, FileKey, Mail } from "lucide-react";
import { useApp } from "@/context/AppProviders";
import { SUPPORT_EMAIL } from "@/config";

const stepIcons = [DownloadCloud, Cpu, FileKey];

const Activation = () => {
  const { t } = useApp();

  return (
    <section
      id="activation"
      data-testid="activation-section"
      className="py-24 sm:py-32 border-t border-border"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl"
        >
          <p className="font-mono text-sm uppercase tracking-widest text-blue-500">
            {t.activation.label}
          </p>
          <h2 className="font-heading mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
            {t.activation.title}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            {t.activation.subtitle}
          </p>
        </motion.div>

        <div className="mt-16 grid gap-8 md:grid-cols-3 relative">
          {/* connecting line */}
          <div className="hidden md:block absolute top-7 left-[16%] right-[16%] h-px bg-border" />

          {t.activation.steps.map((step, i) => {
            const Icon = stepIcons[i];
            return (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.15 }}
                data-testid={`activation-step-${i + 1}`}
                className="relative flex flex-col items-start"
              >
                <div className="relative z-10 flex h-14 w-14 items-center justify-center rounded-sm border border-blue-600 bg-background text-blue-500">
                  <Icon className="h-6 w-6" strokeWidth={2} />
                  <span className="absolute -top-2 -right-2 flex h-6 w-6 items-center justify-center rounded-sm bg-blue-600 font-mono text-xs font-bold text-white">
                    {i + 1}
                  </span>
                </div>
                <h3 className="font-heading mt-5 text-lg font-medium tracking-tight">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                  {step.desc}
                </p>
                {i === 1 && (
                  <a
                    href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(t.activation.hwMail.subject)}`}
                    data-testid="activation-hwid-mail"
                    className="mt-4 inline-flex h-9 items-center gap-2 rounded-sm border border-blue-600/40 bg-blue-600/10 px-3 text-xs font-medium text-blue-500 hover:bg-blue-600 hover:text-white transition-colors duration-200"
                  >
                    <Mail className="h-3.5 w-3.5" />
                    {t.activation.hwMail.btn}
                  </a>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Activation;
